/* eslint-disable react/prop-types */
import React from "react";
import NavBarSimple from "../NavBar/NavBarAuth.js";
import Grid from "@material-ui/core/Grid";
import { NavLink, Link } from "react-router-dom";
import { withTranslation } from "react-i18next";

function TraspasoOk(props) {
  const { t, i18n } = props;
  return (
    <div className="fullPage">
      <NavBarSimple />
      <div className="defaultFull">
        <Grid container spacing={3} justifyContent="center" className="defaultgrid">
          <Grid item xs={12}>
            <div className="h1home">{t("tool.cuentatraspasada")}</div>

            <div
              className="txtHome marginSubTitle"
              dangerouslySetInnerHTML={{
                __html: t("tool.cuentaeliminfo", {
                  interpolation: { escapeValue: false },
                }),
              }}
            />

            <div className="subh1home marginSubTitle">
              {t("tool.cuentaeliminfo1")}
            </div>
          </Grid>
          <Grid item xs={12}>
            <NavLink to="/user/login" className="btn btnHome">
              {t("volverinicio")}
            </NavLink>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
export default withTranslation()(TraspasoOk);
